import { StaticLayer } from '../../types/static-layers.types';
import { MapLayer } from './maps-base-layer';
import { safelyAddLayer } from './maps.utils';
import * as mapboxgl from 'mapbox-gl/esm';

export class StaticMapLayer extends MapLayer {
  constructor(public layer: StaticLayer) {
    super();
    this.id = layer.id;
  }

  async addTo(map: mapboxgl.Map): Promise<void> {
    const layer = this.layer;
    this.map = map;

    const layerConfig: mapboxgl.FillLayerSpecification = {
      'id': this.id,
      'type': 'fill',
      'source': layer.source,
      'source-layer': layer.sourceLayer || layer.id,
      paint: {
        'fill-opacity': 0.6,
        'fill-outline-color': '#000',
        'fill-color': layer.color,
        ...layer.paintConfig
      },
      layout: layer.layoutConfig || {}
    };

    const highlightConfig: mapboxgl.LineLayerSpecification = {
      'id': this.id + '-highlight',
      'type': 'line',
      'source': layer.source,
      'source-layer': layer.sourceLayer || layer.id,
      paint: {
        'line-color': '#fff',
        'line-width': 3,
        'line-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0]
      }
    };

    safelyAddLayer(map, layerConfig);
    safelyAddLayer(map, highlightConfig);
  }

  layerIds(): string[] {
    return [this.id, this.id + '-highlight'];
  }

  remove(): void {
    if (this.map && this.map.getLayer(this.id)) {
      this.map.removeLayer(this.id);
    }
      if (this.map && this.map.getLayer(this.id + '-highlight')) {
      this.map.removeLayer(this.id + '-highlight');
    }
  }

  setOpacity(opacity: number): void {
    if (this.map && this.map.getLayer(this.id)) {
      this.map.setPaintProperty(this.id, 'fill-opacity', opacity);
    }
  }
}